import { FilterGroupsTable } from '../components/FilterGroupsTable';

export const MyFilterGroups = ({ isMobile, model }) => {
  return <FilterGroupsTable isMobile={isMobile} model={model} isMine />;
};
